<div class="modal-header">
    <i class="fas fa-exclamation-circle fa-2x warnIcon" *ngIf="warn && !infoText"></i>
    <i class="fas fa-question-circle fa-2x confirmationIcon" *ngIf="!warn && !infoText"></i>
    <i class="fas fa-info-circle fa-2x infoIcon" *ngIf="!warn && infoText"></i>
    <h4 id="alert-modal-title" class="modal-title warnTittle pl-2" *ngIf="warn">{{'common.warn' | translate}}</h4>
    <h4 class="modal-title confirmationTittle" *ngIf="!warn">{{ 'common.confirmation.confirmation' | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <p *ngIf="infoText">{{ infoText | translate}}</p>
    <p>{{ message | translate}}</p>
    <p>{{ objectText }}</p>
    <ul class="list-group" *ngIf="causes && causes.length !== 0">
        <li class="list-group-item" *ngFor="let cause of causes">{{cause | translate}}</li>
    </ul>
    <hr/>
    <div *ngIf="otherWarnMessage">
        <p><i class="fas fa-exclamation-triangle warnIcon"></i> {{ otherWarnMessage | translate}}</p>
        <ul class="list-group">
            <li class="list-group-item" *ngFor="let otherCause of otherWarnCauses">{{otherCause | translate}}</li>
        </ul>
    </div>
    
    <form *ngIf="withComment">
        <div class="form-group">
            <label for="comment">{{'common.comments' | translate}}</label>
            <textarea class="form-control" id="comment" rows="3" [(ngModel)]="comments" name="comments" autofocus></textarea>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="decline()">{{ btnCancelText | translate }}</button>
    <button type="button" ngbAutoFocus class="btn btn-primary" (click)="accept()">{{ btnOkText | translate }}</button>
</div>